





import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Helpers
 */

/**
 * Components
 */

/**
 * API
 */

/**
 * Page d'accueil de l'espace Agent.
 */
@Component
export default class AgentHomePage extends Vue {
	async created() {

	}
}
